var map = {
	"./calculatorButtonBg.png": 26509,
	"./cawslogo.png": 1007,
	"./decrease.png": 57304,
	"./earnHeroMobileBg.png": 18273,
	"./gold.png": 70514,
	"./increase.png": 42412,
	"./lanft-poolicon.png": 30429,
	"./metamaskVideo.png": 17722,
	"./mrsbunny.png": 97216,
	"./newCawsLogo.png": 15363,
	"./newPool.png": 99934,
	"./silver.png": 8835,
	"./stakeVideo.png": 71523,
	"./toppools-bg.png": 71172,
	"./tvlBackground.png": 97160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12055;